import React, { FunctionComponent, useEffect, useState } from "react";
import styles from "./ImportModal.module.css";
import Modal, { Styles } from "react-modal";
import { IoIosClose } from "react-icons/io";
import Loading from "../../Components/Loading/Loading";
import moment from "moment";
import { motion, AnimatePresence } from "framer-motion/dist/framer-motion";
import { connect, useDispatch } from "react-redux";
import Backdrop from "../../Components/Backdrop/Backdrop";
import { themeColors } from "../../Components/theme";
import CSVGenerator from "../../Components/Modals/ImportModal/CSVGenerator";
import { fetchLeadSourceFile, uploadLeadSourceFile } from "../../Services/contacts";
import { Circles } from "react-loader-spinner";
import { useMediaQuery, useTheme } from "@mui/material";
import "../../theme-vars.css";
import StyledSubmitButton from "../../Components/Buttons/StyledSubmitButton";
import StyledCancelButton from "../../Components/Buttons/StyledCancelButton";

type props = {
    theme?: any;
    open?: any;
    close: () => void;
    organization_id?: string;
    history?: any;
    usersList?: any[];
    user?: any;
};

interface DataObject {
    [key: string]: any;
}

const ImportModelLeadSource: FunctionComponent<props> = ({
    theme,
    open,
    close,
    organization_id,
    history,
    usersList,
    user,
}) => {
    const dispatcher = useDispatch();
    const themeMUI = useTheme();
    const isMobile = useMediaQuery(themeMUI.breakpoints.down("sm"));
    const [load, setLoad] = useState(false);
    const [uploadedFiles, setUploadedFiles] = useState<any[]>([]);
    const leadSourceHeaderData: DataObject[] = [];
    leadSourceHeaderData.push(['leadSource']);

    useEffect(() => {
        if (organization_id) {
            const unsub = fetchLeadSourceFile(
                organization_id,
                (data: any) => setUploadedFiles(data),
                dispatcher
            );
            return () => {
                unsub();
            };
        }
    }, [organization_id]);

    const upload = async (file: any) => {
        const orgId: any = organization_id
        setLoad(true);
        uploadLeadSourceFile(
            file,
            orgId,
            dispatcher,
            (data: boolean) => setLoad(data),
            user.user_first_name + " " + user.user_last_name
        );
    };
    const tdStyles = {
        backgroundColor: theme ? themeColors.tdBackgroundColor : themeColors.tdBackgroundColorDark,
        color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark,
    }
    const thStyles = {
        backgroundColor: theme ? themeColors.thBackgroundColor : themeColors.thBackgroundColorDark, color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark
    }

    const modalStyle: Styles = {
        overlay: {
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            zIndex: 1300,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
        },
        content: {
            background: theme
                ? themeColors.cardBackgroundColor
                : themeColors.cardBackgroundColorDark,
            color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark,
            borderRadius: 16,
            padding: isMobile ? "24px 12px" : "10px 20px",
            border: "none",
            boxShadow: "0 8px 32px rgba(0,0,0,0.18)",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            position: "relative",
            inset: "auto",
            margin: "auto",
        },
    };

    return (
        <>
            <Modal
                isOpen={open}
                onRequestClose={close}
                shouldCloseOnOverlayClick={true}
                shouldCloseOnEsc={true}
                style={modalStyle}
                ariaHideApp={false}
            >
                <div className={styles.child}>
                    <h5 style={{ fontFamily: "var(--font-family-main)", fontSize: "var(--font-size-large)", paddingTop: isMobile ? "unset" : "15px" }}>Import Data for "Lead Source Form"</h5>
                    <div className={styles.tableBox}>
                        <table className={styles.table}>
                            <thead className={styles.head} style={{ fontFamily: "var(--font-family-main)", fontSize: "var(--font-size-small)" }} >
                                <tr>
                                    <th className={styles.th} style={thStyles}>Sno.</th>
                                    <th className={styles.th} style={thStyles}>Request Id</th>
                                    <th className={styles.th} style={thStyles}>Created At</th>
                                    <th className={styles.th} style={thStyles}>Status</th>
                                    <th className={styles.th} style={thStyles}>Upload Count</th>
                                    <th className={styles.th} style={thStyles}>Uploaded File</th>
                                    <th className={styles.th} style={thStyles}>Processed File</th>
                                </tr>
                            </thead>
                            <tbody style={{ fontFamily: "var(--font-family-main)", fontSize: "var(--font-size-medium)" }}>
                                {uploadedFiles.map((item: any, index: number) => (
                                    <tr key={index} className={styles.no}>
                                        <td className={styles.td} style={tdStyles}>{index + 1}</td>
                                        <td className={styles.td} style={tdStyles}>{item.request_id}</td>
                                        <td className={styles.td} style={tdStyles}>
                                            {moment(item.created_at.toDate()).format("MM/DD/YY HH:mm")}
                                        </td>
                                        <td className={styles.td} style={tdStyles}>{item.status}</td>
                                        <td className={styles.td} style={tdStyles}>{item.uploadCount}</td>
                                        <td className={styles.td} style={tdStyles}>
                                            <a href={item.fileUrl}>Uploaded File</a>
                                        </td>
                                        <td className={styles.td} style={tdStyles}>
                                            {item.responseURL !== "" && (
                                                <a href={item.responseURL}>Processed File</a>
                                            )}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                    <div className={styles.selectBox}>
                        <div style={{ marginRight: 8 }}>
                            <StyledCancelButton onClick={close}>
                                Cancel
                            </StyledCancelButton>
                        </div>
                        <div style={{ marginRight: 8 }}><CSVGenerator data={leadSourceHeaderData} /></div>
                        <div>
                            <input
                                id="file-input"
                                className={styles.select}
                                type="file"
                                accept=".csv,.xlsx,.xls"
                                onChange={(e: any) => upload(e.target.files[0])}
                            />
                            <StyledSubmitButton
                                onClick={() => document.getElementById("file-input")?.click()}
                            >
                                {load ? (
                                    <span style={{ display: "flex", justifyContent: "center" }}>
                                        <Circles color="#fff" height={20} width={20} />Upload...
                                    </span>
                                ) : (
                                    <>Upload File</>
                                )}
                            </StyledSubmitButton>
                        </div>
                    </div>
                    <div style={{ textAlign: "center", marginTop: "1rem" }}>
                        <p style={{ fontFamily: "var(--font-family-main)", fontSize: "var(--font-size-small)" }}><i className="fas fa-info-circle"></i>  Only .csv file type is supported.</p>
                        <p style={{ marginTop: "-1rem", fontFamily: "var(--font-family-main)", fontSize: "var(--font-size-small)" }}><i className="fas fa-info-circle"></i>  Please ensure filling all the mandatory fields.</p>
                    </div>
                </div>
            </Modal>
        </>
    );
};

const mapStateToProps = (state: any) => {
    return {
        theme: state.theme.isLightMode,
        projectHeader: state.projectHeaderList.data,
    };
};
export default connect(mapStateToProps)(ImportModelLeadSource);
